<template>
  <mobialisCard>
    <div class="row">
      <div class="flex-column pl-3">
        <div>
          <font-awesome-icon class="text-primary" :icon="['far', 'info-circle']"></font-awesome-icon>
          <h5 data-test="heading" class="mt-0 mb-2 heading">
            {{ $t('message.credit.application.preQualification.disclaimer.title') }}
          </h5>
        </div>
        <p
          class="mt-1 mb-0"
          v-html-safe="$t('message.credit.application.preQualification.disclaimer.msgPQ')"
          data-test="msgPQ"
        />
        <p
          class="mt-0 mb-0"
          v-html-safe="$t('message.credit.application.preQualification.disclaimer.msgPA')"
          data-test="msgPA"
        />
      </div>
    </div>
  </mobialisCard>
</template>

<script>
export default {
  name: 'PreQualificationDisclaimer',
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
p {
  font-size: 0.875rem;
}
.heading {
  display: inline-block;
  padding-left: 0.75rem;
}
@media only screen and (max-width: $breakpoint-mobile) {
  .heading {
    width: 18rem;
  }
}
@media only screen and (max-width: 348px) {
  .heading {
    width: 12rem;
  }
}
</style>
